<template>
    <i class="fa fa-fw" :class="className"></i>
</template>
<script>
    export default {
        props: {
            loading: Boolean,
            icon: {
                default: ''
            },
        },
        data() {
            return {
            }
        },
        computed: {
            className() {
                if (this.loading) {
                    return 'fa-spinner fa-spin'
                } else {
                    return this.icon
                }
            },
        }
    }
</script>





// WEBPACK FOOTER //
// resources/js/components/Common/Icon.vue